import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../../assets/images/logo-tartina-1.png';
//import logo from '../../assets/images/tartina-logo.svg';

// --- Logo officiel Tartina (wordmark + sourire banane) ---------------------
export const LogoWordmark = ({ to = '/', tagline = true, light = false }) => (
  <LogoLink to={to} aria-label="Tartina — accueil">
    <LogoImg src={logo} alt="Tartina" />
  </LogoLink>
);

const LogoLink = styled(Link)`
  text-decoration: none;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1;
`;

const LogoImg = styled.img`
  height: 46px;
  width: auto;
  display: block;
`;

const Tagline = styled.span`
  margin-top: 6px;
  font-family: ${({ theme }) => theme.fonts.body};
  font-style: italic;
  font-size: 0.72rem;
  color: ${({ $light, theme }) => ($light ? 'rgba(255,255,255,0.85)' : theme.colors.tertiary)};
`;

// --- Doodle cœur dessiné main (accent décoratif) ---------------------------
export const HeartDoodle = ({ size = 28, color = '#E30613', style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
    style={style}
  >
    <path
      d="M32 56C12 42 6 30 6 21 6 13 12 8 19 8c6 0 10 4 13 9 3-5 7-9 13-9 7 0 13 5 13 13 0 9-6 21-26 35Z"
      fill="none"
      stroke={color}
      strokeWidth="4"
      strokeLinejoin="round"
    />
    <path d="M44 18c3 0 5 2 5 6" stroke={color} strokeWidth="3" strokeLinecap="round" fill="none" />
  </svg>
);

// --- Séparateur en vagues (bord festonné entre deux sections) --------------
export const WaveDivider = ({ color = '#FFFBF2', flip = false }) => (
  <WaveWrap $flip={flip} aria-hidden="true">
    <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
      <path
        d="M0,40 C120,80 240,80 360,55 C480,30 600,30 720,50 C840,70 960,70 1080,48 C1200,28 1320,28 1440,45 L1440,80 L0,80 Z"
        fill={color}
      />
    </svg>
  </WaveWrap>
);

const WaveWrap = styled.div`
  line-height: 0;
  transform: ${({ $flip }) => ($flip ? 'rotate(180deg)' : 'none')};
  svg { width: 100%; height: 56px; display: block; }
`;

// --- Badge social (signature des visuels Tartina) --------------------------
export const SocialBadge = () => (
  <Badge>
    <span role="img" aria-label="pouce">👍</span>
    <em>J'aime · Commente · Partage</em>
  </Badge>
);

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: ${({ theme }) => theme.colors.primary};
  color: #fff;
  padding: 6px 14px;
  border-radius: ${({ theme }) => theme.borderRadius.pill};
  font-size: 0.78rem;
  font-weight: 700;
  font-style: normal;
  em { font-style: normal; }
`;
